import { useTransportAndTransportOptions } from 'Components/pages/VehicleDetailsRedesign/transport/useTransportAndTransportOptions';

export const DELIVERY_ACTIONS = {
	BOOK: 'book',
	VIEW: 'view',
} as const;

export const useDeliveryAction = () => {
	const { data, isError, isLoading } = useTransportAndTransportOptions();

	if (isLoading || isError) {
		return { deliveryAction: null };
	}

	const { isCancelled, noTransportEntry, noTransportTypeSet, selectedTransport } = data.transport;

	const hasPreviouslyBookedDelivery = Boolean(selectedTransport || isCancelled);

	const isValidDeliveryActionState = hasPreviouslyBookedDelivery || Boolean(noTransportTypeSet || noTransportEntry);

	if (!isValidDeliveryActionState) {
		return { deliveryAction: null };
	}

	const deliveryAction = hasPreviouslyBookedDelivery ? DELIVERY_ACTIONS.VIEW : DELIVERY_ACTIONS.BOOK;

	return {
		deliveryAction,
	};
};
